export default __webpack_public_path__ + "static/media/AcornOffice_24.07ae2969.png";